import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CutOutRibKnit = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.CutOutRibKnit.itemName}
      name={AW23.tops.CutOutRibKnit.itemName}
      price={AW23.tops.CutOutRibKnit.itemPrice}
      fabric={AW23.tops.CutOutRibKnit.itemFabric}
      src={AW23.tops.CutOutRibKnit.sizeChart}
      divId={AW23.tops.CutOutRibKnit.shopifyDivId}
      mainId={AW23.tops.CutOutRibKnit.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.CutOutRibKnit.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.CutOutRibKnit.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CutOutRibKnit;
